export default __webpack_public_path__ + "static/media/medaille-qdo-argent-conception.5622d579.png";